<div class="multi-select-control dropdown-full-width" ngbDropdown container="body" autoClose="outside" (openChange)="onOpenChange($event)">
  <button class="form-control form-control-alt multi-select-btn" [disabled]="isDisabled" ngbDropdownToggle data-cy="DropdownToggle" [class.form-control-without-value]="!selection.length">
    <span [ngbTooltip]="selectedLabels" container="body">
      @if (!!selection.length) {
        @if (isSelectAllChecked) {
          {{ config.translationKey + '.AllSelected' | translate }}
        }
        @if (!isSelectAllChecked) {
          @if (config.showSelectedLabels && !!selectedLabels) {
            {{ selectedLabels }}
          }
          @if (!config.showSelectedLabels) {
            {{ (config.translationKey + '.SelectedItems' | plural: selectionCount) | translate : { count: selectionCount } }}
          }
        }
      }
      @if (!selection.length) {
        @if (config.noneSelectedkey) {
          {{ config.noneSelectedkey | translate }}
        } @else if (isDisabled) {
          &nbsp;
        } @else {
          {{ config.translationKey + '.SelectEmpty' | translate }}
        }
      }
    </span>
  </button>
  <div ngbDropdownMenu class="multi-select-list">
    @if (config.canSelectAll) {
      <div ngbDropdownItem class="form-check">
        <input
          ngbTooltip="{{config.allSelectValue}}"
          container="body"
          id="{{ componentId }}-all"
          class="form-check-input"
          type="checkbox"
          name="selection"
          [ngModel]="isSelectAllChecked"
          (ngModelChange)="toggleAll($event)"
          [value]="config.allSelectValue" />
        <label for="{{ componentId }}-all" class="form-check-label">{{ config.translationKey + '.SelectAll' | translate }}</label>
      </div>
      <div class="dropdown-divider"></div>
    }
    @for (item of items; track item) {
      <div ngbDropdownItem class="form-check">
        <input
          ngbTooltip="{{item[config.valueProp]}}"
          container="body"
          id="{{ componentId }}-{{ item[config.valueProp] }}"
          class="form-check-input"
          type="checkbox"
          name="selection"
          [disabled]="(isItemSelected(item) || canSelectMore) ? undefined : true"
          [ngModel]="isItemSelected(item)"
          (ngModelChange)="toggleItem($event, item)"
          [value]="item[config.valueProp]" />
        <label for="{{ componentId }}-{{ item[config.valueProp] }}" class="form-check-label">
          {{ getLabel(item[config.labelProp]) }}
          @if (config.canSelectOnly) {
            <a href="" (click)="selectOnly($event, item)" translate="{{ config.translationKey + '.SelectOnly' }}"></a>
          }
        </label>
      </div>
    }
  </div>
</div>
@if (config.canClearSelection && !isDisabled && !!selection.length) {
  <button class="btn-link multi-select-clear" (click)="onClear()">{{ config.translationKey + '.ClearSelection' | translate : { count: selectionCount } }}</button>
}
